import { render, staticRenderFns } from "./bulk-message-template-view-all-cards.vue?vue&type=template&id=24e546bc&scoped=true&"
import script from "./bulk-message-template-view-all-cards.vue?vue&type=script&lang=js&"
export * from "./bulk-message-template-view-all-cards.vue?vue&type=script&lang=js&"
import style0 from "./bulk-message-template-view-all-cards.vue?vue&type=style&index=0&id=24e546bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e546bc",
  null
  
)

export default component.exports